(function productComponentsRuntime(window, document) {
  'use strict';

  if (!window || !document || !window.customElements) return;

  function loadProd004Evidence() {
    if (document.querySelector('script[data-prod-004-product-evidence]')) return;

    var current = document.currentScript;
    if (!current || !current.src) return;

    var source = new URL(current.src, window.location.href);
    source.pathname = source.pathname.replace(/product-components-runtime\.js$/, 'prod-004-product-evidence.js');

    var script = document.createElement('script');
    script.src = source.toString();
    script.defer = true;
    script.setAttribute('data-prod-004-product-evidence', 'true');
    document.head.appendChild(script);
  }

  loadProd004Evidence();

  if (window.customElements.get('variant-selects')) return;

  // Ownership boundary:
  // - variant-selects owns option UI metadata and publishes selected option value IDs.
  // - product-info owns server rendering, variant authority and product DOM replacement.
  // - this runtime must not resolve a variant from a second client-side product model.
  var eventNames = window.PUB_SUB_EVENTS || {};
  var optionChangeEvent = eventNames.optionValueSelectionChange || 'option-value-selection-change';
  var publish = typeof window.publish === 'function'
    ? window.publish.bind(window)
    : function publishFallback(eventName, payload) {
        document.dispatchEvent(new CustomEvent(eventName, { detail: payload || {} }));
        return Promise.resolve();
      };

  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      if (this.__littlegVariantSelectsConnected) return;
      this.__littlegVariantSelectsConnected = true;
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      this.__littlegVariantSelectsConnected = false;
    }

    handleChange(event) {
      var target = this.getInputForEventTarget(event.target);
      if (!target) return;

      this.updateSelectionMetadata(event);

      publish(optionChangeEvent, {
        data: {
          event: event,
          target: target,
          selectedOptionValues: this.selectedOptionValues
        }
      });
    }

    updateSelectionMetadata(event) {
      var target = event && event.target;
      if (!target) return;

      if (target.tagName === 'SELECT' && target.selectedOptions && target.selectedOptions.length) {
        var previous = Array.prototype.find.call(target.options, function findSelected(option) {
          return option.hasAttribute('selected');
        });
        if (previous) previous.removeAttribute('selected');

        var selectedOption = target.selectedOptions[0];
        selectedOption.setAttribute('selected', 'selected');

        var group = target.closest('.product-form__input');
        var selectedSwatch = group && group.querySelector('[data-selected-value] > .swatch');
        if (!selectedSwatch) return;

        var swatchValue = selectedOption.dataset.optionSwatchValue;
        if (swatchValue) {
          selectedSwatch.style.setProperty('--swatch--background', swatchValue);
          selectedSwatch.classList.remove('swatch--unavailable');
        } else {
          selectedSwatch.style.setProperty('--swatch--background', 'unset');
          selectedSwatch.classList.add('swatch--unavailable');
        }

        selectedSwatch.style.setProperty(
          '--swatch-focal-point',
          selectedOption.dataset.optionSwatchFocalPoint || 'unset'
        );
        return;
      }

      if (target.tagName === 'INPUT' && target.type === 'radio') {
        var inputGroup = target.closest('.product-form__input');
        var selectedValue = inputGroup && inputGroup.querySelector('[data-selected-value]');
        if (selectedValue) selectedValue.textContent = target.value;
      }
    }

    getInputForEventTarget(target) {
      if (!target) return null;
      return target.tagName === 'SELECT' && target.selectedOptions ? target.selectedOptions[0] : target;
    }

    get selectedOptionValues() {
      return Array.prototype.map.call(
        this.querySelectorAll('select option[selected], fieldset input:checked'),
        function optionValue(element) {
          return element.dataset.optionValueId;
        }
      ).filter(Boolean);
    }
  }

  window.customElements.define('variant-selects', VariantSelects);
})(window, document);
